import styles from './KnmChangeWarning.module.scss';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import { convertArrayToDate } from '../common/convertArrayToDate';
import {
  DATE_FORMAT_LONG_FNS,
  SYSTEM_DATE_FORMAT_SHORT_FNS,
} from '../../../CorePackage/MainModule/constants/dateFormats';
import { IOldNameControllingSubject } from '../../../APIPackage/KnmModule/interfaces/IOldNameControllingSubject';

interface IKnmChangeWarningProps {
  type: 'KNO' | 'SUBJECT_OBJECT';
  oldKnoOrganization?: string | null;
  date?: number[] | null;
  oldNameControllingSubject?: IOldNameControllingSubject[] | null;
}

export const KnmChangeWarning = ({
  type,
  oldKnoOrganization,
  date,
  oldNameControllingSubject,
}: IKnmChangeWarningProps) => {
  if (!date) {
    return null;
  }

  const formattedDate = formatDate({
    date: convertArrayToDate(date),
    dateFormat: DATE_FORMAT_LONG_FNS,
    parseFormat: SYSTEM_DATE_FORMAT_SHORT_FNS,
  });

  let message: string;

  if (type === 'KNO') {
    if (!oldKnoOrganization?.trim()) return null;
    message = `Наименование органа контроля было изменено ${formattedDate}, наименование органа до смены: «${oldKnoOrganization}»`;
  } else {
    // eslint-disable-next-line no-nested-ternary
    const items = Array.isArray(oldNameControllingSubject)
      ? oldNameControllingSubject
      : oldNameControllingSubject
      ? [oldNameControllingSubject]
      : [];

    const names = items
      .filter(item => !item.type || item.type === 'SUBJECT')
      .map(item => item.organizationName?.trim())
      .filter((name): name is string => Boolean(name));

    if (!names.length) return null;
    const namesText = names.map(name => `«${name}»`).join(', ');

    message =
      names.length > 1
        ? `Наименования проверяемых лиц были изменены ${formattedDate}, наименования проверяемых лиц до смены: ${namesText}`
        : `Наименование проверяемого лица было изменено ${formattedDate}, наименование проверяемого лица до смены: ${namesText}`;
  }

  return (
    <div className={styles.Hint} role="status">
      <span className={styles.Icon} aria-hidden="true">
        !
      </span>
      <span className={styles.Text}>{message}</span>
    </div>
  );
};
